const e = {
  name: "RefreshSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 10H18V4H16V6.25427C14.8674 5.4652 13.4881 5 12 5C8.13772 5 5 8.13772 5 12C5 15.8623 8.13772 19 12 19C15.8623 19 19 15.8623 19 12H17C17 14.7577 14.7577 17 12 17C9.24228 17 7 14.7577 7 12C7 9.24228 9.24228 7 12 7C13.1267 7 14.1664 7.37289 15.0018 8H12V10Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as RefreshSmall
};
